import RcInstanceDTO from '@robocorp/robocloud-internal-cds-sdk/lib/sdk/Types';
import { combineReducers } from 'redux';
import produce from 'immer';
import {
  ActivityTemplateAction,
  ActivityTemplateActionType,
} from '../../actions/activityTemplateActions';
import { PackageAction, PackageActionType } from '../../actions/packageActions';

interface TemplateState {
  byId: Record<string, RcInstanceDTO.ActivityTemplate>;
  allIds: string[];
}

export const initialState: TemplateState = {
  byId: {},
  allIds: [],
};

const byId = (state = initialState.byId, action: ActivityTemplateAction | PackageAction) =>
  produce(state, (draft) => {
    switch (action.type) {
      case ActivityTemplateActionType.GET_ACTIVITY_TEMPLATES:
        return {};
      case ActivityTemplateActionType.GET_ACTIVITY_TEMPLATES_OK: {
        action.data.forEach((activityTemplate) => {
          draft[activityTemplate.id] = activityTemplate;
        });

        break;
      }
      case ActivityTemplateActionType.GET_ACTIVITY_TEMPLATE_OK: {
        draft[action.id] = action.data;
        break;
      }
      case ActivityTemplateActionType.CREATE_ACTIVITY_TEMPLATE_OK: {
        draft[action.data.id] = action.data;
        break;
      }
      case ActivityTemplateActionType.EDIT_ACTIVITY_TEMPLATE_OK: {
        draft[action.data.id] = action.data;
        break;
      }
      case ActivityTemplateActionType.DELETE_ACTIVITY_TEMPLATE_OK: {
        delete draft[action.id];
        break;
      }
      case PackageActionType.GET_PACKAGE_UPLOAD_INFO_OK: {
        delete draft[action.id]?.config?.globalPackageName;
        break;
      }
      case PackageActionType.PACKAGE_BUILDING_PROGRESS:
      case PackageActionType.PACKAGE_PROCESSING_COMPLETED: {
        draft[action.data.id] = action.data;
        break;
      }
      default:
        return state;
    }
  });

const allIds = (state = initialState.allIds, action: ActivityTemplateAction) => {
  switch (action.type) {
    case ActivityTemplateActionType.GET_ACTIVITY_TEMPLATES:
      return [];
    case ActivityTemplateActionType.GET_ACTIVITY_TEMPLATES_OK:
      return action.data.map((templ) => templ.id);
    case ActivityTemplateActionType.GET_ACTIVITY_TEMPLATE_OK:
      return state.includes(action.data.id) ? state : [...state, action.data.id];
    case ActivityTemplateActionType.DELETE_ACTIVITY_TEMPLATE_OK:
      return state.filter((id) => id !== action.id);
    case ActivityTemplateActionType.CREATE_ACTIVITY_TEMPLATE_OK:
      return [...state, action.data.id];
    default:
      return state;
  }
};

export default combineReducers({ byId, allIds });
